import type { FormDataOf, FormDataValue } from '../../../../../types/templates';
import { disneyEspnHero } from '..';
import { getLeagueBackgrounds } from '../urls';

type FormData = FormDataOf<typeof disneyEspnHero>;

export const applyFieldLogic = (fieldKey: string, value: FormDataValue, _formData: FormData): Partial<FormData> => {
  const updates: Partial<FormData> = {};

  if (fieldKey === 'league') {
    updates.teams = { slot1: '', slot2: '' };
    updates.players = [];
    updates.backgrounds = value ? getLeagueBackgrounds(value as string) : undefined;
  }

  if (fieldKey === 'teams') {
    updates.players = [];
  }

  return updates;
};
